export const stringToBlob = (base64Data) => {
  try {
    const parts = base64Data.split(";base64,");
    if (parts.length !== 2) {
      console.error("Định dạng data URL base64 không hợp lệ");
      return null;
    }

    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    const blob = new Blob([uInt8Array], { type: contentType });
    return { blob, type: contentType };
  } catch (error) {
    console.error("Lỗi khi chuyển đổi base64 sang Blob", error);
    return null;
  }
};
